module.exports = __webpack_public_path__ + "static/media/1 45 sendt.2aacaa9e.mp3";